export const PROJECT_STATUSES = ['Planned', 'Ongoing', 'Completed'];

// Only these statuses represent funds that have actually left the treasury.
export const DISBURSED_STATUSES = new Set(['Ongoing', 'Completed']);
